import { NameResourceItem } from "../NameResourceItem";
import { createListResource } from "../../list";

export type Kolor = NameResourceItem;

export const kolorResource = createListResource<Kolor>("plm/kolory/");
